module.exports = __webpack_public_path__ + "img/LE.ddbdd9d7.png";